import React from 'react'
import { Breadcrumb } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Breadcrumbs = ({ data }) => {
  return (
    <Breadcrumb className="breadcrumb-chevron">
      {data.map((item) => (
        <Breadcrumb.Item key={item.title}>
          {item.url !== undefined ? (
            <Link to={item.url}>{item.title}</Link>
          ) : (
            item.title
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  )
}

export default Breadcrumbs

export const DMSBreadcrumbs = {
  PRODUCT: [
    { title: 'Home', url: '/dashboard' },
    { title: 'บัญชียาและเวชภัณฑ์' },
  ],
  COMPANY: [{ title: 'Home', url: '/dashboard' }, { title: 'บัญชีบริษัท' }],
  PURCHASE_ORDER: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จัดการใบสั่งซื้อ' },
  ],
  PURCHASE_ORDER_DETAIL: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จัดการใบสั่งซื้อ', url: '/dms/order' },
    { title: 'สั่งซื้อยาและเวชภัณฑ์' },
  ],
  RECEPTION: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จัดการใบรับของ' },
  ],
  RECEPTION_DETAIL: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จัดการใบรับของ', url: '/dms/receipt' },
    { title: 'รับยาและเวชภัณฑ์' },
  ],
  DRAWAL: [
    { title: 'Home', url: '/dashboard' },
    { title: 'ขอเบิกจากคลังใหญ่' },
  ],
  DRAWAL_DETAIL: [
    { title: 'Home', url: '/dashboard' },
    { title: 'ขอเบิกระหว่างคลังย่อย', url: '/dms/drawal' },
    { title: 'ขอเบิก' },
  ],
  PAYOUT: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จ่ายออกจากคลังใหญ่' },
  ],
  PAYOUT_DETAIL: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จ่ายออกจากคลังใหญ่', url: '/dms/payout' },
    { title: 'จ่ายออก' },
  ],
  DRAWAL_SUB: [
    { title: 'Home', url: '/dashboard' },
    { title: 'ขอเบิกระหว่างคลังย่อย' },
  ],
  DRAWAL_SUB_DETAIL: [
    { title: 'Home', url: '/dashboard' },
    { title: 'ขอเบิกระหว่างคลังย่อย', url: '/dms/drawal-subdepot' },
    { title: 'ขอเบิก' },
  ],
  PAYOUT_SUB: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จ่ายออกจากคลังย่อย' },
  ],
  PAYOUT_SUB_DETAIL: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จ่ายออกจากคลังย่อย', url: '/dms/payout-subdepot' },
    { title: 'จ่ายออก' },
  ],
  SUB_TREASURY: [
    { title: 'Home', url: '/dashboard' },
    { title: 'บริหารคลังย่อย' },
  ],
  REORDER: [
    { title: 'Home', url: '/dashboard' },
    { title: 'รายการถึงจุดสั่งซื้อ' },
  ],
  BUDGET: [
    { title: 'Home', url: '/dashboard' },
    { title: 'บริหารจัดการงบประมาณ' },
  ],
  STOCK: [
    { title: 'Home', url: '/dashboard' },
    { title: 'ปรับปรุงสต็อกปิดงวด' },
  ],
  PRODUCTION: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จัดการรายการผลิต' },
  ],
  DRUGCODE: [
    { title: 'Home', url: '/dashboard' },
    { title: 'จัดการรหัสยามาตรฐาน' },
  ],
}
